import { Component } from 'js-component-framework';
import { AriaPopup } from 'js-component-framework/lib/plugins';

/**
 * Component for search page dropdowns functionality
 */
export default class SearchPageFilter extends Component {
  static clickHandler(event, popup) {
    event.preventDefault();
    event.stopPropagation();
    popup.ariaToggle(event);
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  init() {
    const {
      controller,
      target,
      facets,
    } = this.children;

    if (! controller || ! target) {
      return;
    }

    const {
      options: {
        ariapopup: attributes,
      },
    } = this;

    this.popup = new AriaPopup({
      controller,
      target,
      attributes,
    });

    if (controller.hasAttribute('data-start-open')) {
      this.popup.ariaShow();
    }

    controller.addEventListener('click', (e) => SearchPageFilter
      .clickHandler(e, this.popup));

    if (4 < target.children.length) {
      const clickSeeMore = (event, btn) => {
        event.preventDefault();
        event.stopPropagation();
        btn.classList.toggle('toggleable-hidden');
        facets.forEach((el) => {
          el.classList.toggle('toggleable-hidden');
        });
      };

      const seeMoreButton = document.createElement('button');
      seeMoreButton.classList = 'filter-showme-button';
      seeMoreButton.innerHTML = 'See More +';
      seeMoreButton.addEventListener('click', (e) =>
        clickSeeMore(e, seeMoreButton));
      target.append(seeMoreButton);
    }
  }
}
